import { useContext, useState } from 'react';
import InvestoryIcon from '../../docs/light/warehouse.png';
import trashIcon from '../../docs/light/trash.png';
import EditIcon from '../../docs/light/edit.png';
import Display from '../../docs/light/eye.png';
import Action from '../../docs/light/add.png';
import { action } from '../../context/action';
import { deleteItem, mainSearch, secondarySearch, update } from '../indexDB/indexDBStora';
import { switchh } from '../../context/switch';
import { scenes } from '../../context/scenes';
import { useTranslation } from 'react-i18next';
import { dataa } from '../../context/data';

export default function InvoiceCard(props) {
    const { t } = useTranslation();
    const { setErrorMessage, setSuccessMessage, editMode, setEditMode } = useContext(action);
    const { setLoadingProcess, setEnableAddInInvenotry } = useContext(switchh);
    const { setDataEnv } = useContext(scenes);
    const { setBatches } = useContext(dataa) 

    const [editTextInv, setEditTextInv] = useState("");

    const inventory = props?.data || {};

    /* ================= DELETE ================= */

    const deleteInvestory = async (id) => {
        setErrorMessage("");
        setSuccessMessage("");

        if (!id) {
            setErrorMessage(t("error:investory.invNotFound"));
            return;
        }
        
        try {
            const isFound = await mainSearch("warehouse", id);
            if(isFound.box.length !== 0) {
                setErrorMessage(t("error:investory.canNotDelete"));
                return;
            }
            setLoadingProcess(true);
            await deleteItem("warehouse", id);
            setSuccessMessage(t("common:investory.deleteDone"));
        } catch (error) {
            console.log(error);
            setErrorMessage(t("error:investory.unexpectedError"));
        } finally {
            setLoadingProcess(false);
        }
    };


    /* ================= EDIT ================= */

    const EditInvestory = async (id) => {

        setErrorMessage("");
        setSuccessMessage("");

        if (!id) {
            setErrorMessage(t("error:investory.invNotFound"));
            return;
        }

        const trimmedName = editTextInv.trim();

        if (trimmedName === "") {
            setErrorMessage(t("common:Stillempty"));
            return;
        }

        if (trimmedName === inventory.name) {
            setErrorMessage(t("error:investory.repeated"));
            return;
        }

        try {

            setLoadingProcess(true);

            const findSameName = await secondarySearch("warehouse", "name", trimmedName);

            if (findSameName.length !== 0) {
                setErrorMessage(t("error:investory.repeated"));
                return;
            }

            const getwareHouse = await mainSearch("warehouse", id);

            if (!getwareHouse) {
                setErrorMessage(t("error:investory.invNotFound"));
                return;
            }

            getwareHouse.name = editTextInv;
            
            await update("warehouse", getwareHouse);

            setSuccessMessage(t("common:investory.updated"));
            setEditMode(null);
            setEditTextInv("");

        } catch (error) {
            console.log(error);
            setErrorMessage("حدث خطأ أثناء التحديث");
        } finally {
            setLoadingProcess(false);
        }
    };

    /* ================= DISPLAY ================= */
    const DisplayProducts = async () => {
        if(!inventory) return;
        const batches = await secondarySearch("batches", "inventoryId", inventory.id);
        if(!batches) return;
        setBatches(batches);
    }


    return (
        <div className="investoryBtn">
            <div className="action flex">

                <button
                    onClick={() => {
                        setEditMode(inventory.id);   // نخزن الـ id هنا
                        setEditTextInv(inventory.name);
                    }}
                    className='option'
                >
                    <img src={EditIcon} alt='edit' width={'15'} />
                </button>

                <button
                    onClick={() => deleteInvestory(inventory.id)}
                    className='option'
                >
                    <img src={trashIcon} alt='trash' width={'15'} />
                </button>
                
                <button
                    onClick={() => DisplayProducts()}
                    className='option'
                >
                    <img src={Display} alt='trash' width={'15'} />
                </button>

                <button
                    onClick={() => setEnableAddInInvenotry(inventory)}
                    className='option'
                >
                    <img src={Action} alt='action' width={'15'} />

                </button>

            </div>
            <div className='content'>
                <div className='parent'>
                    <img className='ico-inventory' src={InvestoryIcon} alt='inv-ico' />

                    {editMode === inventory.id ? (

                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                EditInvestory(inventory.id);
                            }}
                            className='edit-box'
                        >
                            <input
                                type='text'
                                value={editTextInv}
                                onChange={(e) => setEditTextInv(e.target.value)}
                                autoFocus
                            />

                            <div className='edit-action flex'>

                                <button type='submit'>update</button>

                                <button
                                    type='button'
                                    onClick={() => {
                                        setEditMode(null);
                                        setEditTextInv("");
                                    }}
                                >
                                    x
                                </button>

                            </div>

                        </form>

                    ) : (

                        <h3>{inventory.name}</h3>

                    )}
                    <p>{inventory.box?.length} {t("common:batches")}</p>
                </div>
            </div>
        </div>
    );
}
